
/**
 * @deprecated Use {@link SerialNumberStrategy} instead.
 */
export enum LegacySerialNumberStrategy {
  AssignByTicketType = 'AssignByTicketType',
  AssignByTicketPrice = 'AssignByTicketPrice',
}
